import React from 'react';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
import {Localizacion} from 'lib.front';

function FormatoFecha(value) {
   if (value) {
      const fecha = new Date(value);
      return fecha.toLocaleString();
   }
   return '-';
}

// Configuracion tabla
export const column = [
   {
      name: 'documento',
      label: 'Documento',
      option: {
         sort: false,
         display: true
      }
   },
   {
      name: 'codigo',
      label: 'Código de activación',
      option: {
         sort: false,
         display: true
      }
   },
   {
      name: 'producto',
      label: 'Producto',
      option: {
         sort: false,
         display: true,
         customBodyRender: value => {
            return FormatoFecha(value);
         }
      }
   },
   {
      name: 'fechaExpiracion',
      label: 'Fecha de expiración',
      opetion: {
         sort: true,
         display: true
      }
   }
];

export const baseOptions = {
   filter: false,
   selectableRows: 'multiple',
   responsive: 'standard',
   expandableRowsHeader: false,
   pagination: true,
   elevation: 0,
   rowsPerPage: 5,
   rowsPerPageOptions: [5, 10, 15, 100],
   search: false,
   print: false,
   download: false,
   viewColumns: false,
   fixedHeader: false,
   selectToolbarPlacement: 'none',
   selectableRowsOnClick: true,
   textLabels: Localizacion.muiDataTables.ES
};
